<section class="customers table-content-card">
    <div class="customers-header mb-4">
        <h3 class="m-0">العملاء</h3>
        <div class="header-actions">
            <!-- CUSTOMERS SEARCH -->
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input
                    class="w-25rem"
                    placeholder="البحث عن عميل"
                    [formControl]="customerSearch"
                    type="text"
                    pInputText />
            </span>
            <!-- NEW CUSTOMER -->
            <p-button icon="pi pi-plus" [routerLink]="['/customers/add']" label="إضافة عميل"></p-button>
        </div>
    </div>
    <!-- CUSTOMERS TABLE -->
    <div class="customers-table">
        <p-table
            [value]="customers"
            (rowsChange)="limit = $event"
            [loading]="loading"
            [scrollable]="true"
            scrollHeight="65vh"
            [tableStyle]="{ 'max-height': '50vh', 'min-height': tableMinHeight, 'overflow-y': 'auto' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>الكود</th>
                    <th>الاسم</th>
                    <th>البريد</th>
                    <th>رقم التليفون</th>
                    <th>الرصيد</th>
                    <th class="w-3 text-center">الإعدادات</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
                <tr>
                    <td>{{ customer.code }}</td>
                    <td>{{ customer.name }}</td>
                    <td>{{ customer.email }}</td>
                    <td>{{ customer.phoneNumber }}</td>
                    <td dir="ltr">{{ customer.dueBalance === 0 ? 0 : (-customer.dueBalance | number: '1.2-2') }}</td>
                    <td class="w-3 text-center">
                        <p-button
                            [outlined]="true"
                            [pTooltip]="'كشف الحساب'"
                            [routerLink]="[urlName, customer.id, 'statement']"
                            tooltipPosition="top"
                            severity="secondary"
                            styleClass="p-button-text p-button-secondary ml-3"
                            icon="pi pi-book">
                        </p-button>
                        <p-button
                            [outlined]="true"
                            [pTooltip]="'تعديل'"
                            [routerLink]="[urlName, customer.id]"
                            appendTo="body"
                            tooltipPosition="top"
                            severity="secondary"
                            styleClass="p-button-text p-button-secondary ml-3"
                            icon="pi pi-pencil">
                        </p-button>
                        <p-button
                            (onClick)="onCustomerDelete($event, customer)"
                            [outlined]="true"
                            appendTo="body"
                            tooltipPosition="top"
                            [pTooltip]="'حـذف'"
                            severity="danger"
                            styleClass="p-button-text p-button-danger"
                            icon="pi pi-trash">
                        </p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <div class="empty-message">
                    <app-empty-state />
                </div>
            </ng-template>
        </p-table>
        <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="0"
            [rows]="perPage"
            [totalRecords]="totalCustomers"
            [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
    </div>
</section>
<p-confirmPopup></p-confirmPopup>
